import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueLabel } from '../../generic/systemValues/systemValueLabel'

/**
 * The types of ONE group, rendered inside the accordion of its group row.
 *
 * Mirror of `ProfilePermissionAccordionChilds.jsx`, with one deliberate difference: the mould
 * re-queries the server for each accordion level, while here the whole catalogue and the whole
 * subscription state arrive in a single payload (contrato-jupiter-sun.md §2, §3), so the types and
 * their state come down as props. One payload, no N+1.
 *
 * A group with no types (INTEGRATIONS, RN7) renders an empty table: it stays subscribable as a group
 * and there is simply nothing below it (S120).
 */
const AlarmSubscriptionTypes = ({ types, renderToggle, renderOrigin, renderJobFilter }) => {
  const { t_ } = useSmartTranslation()

  const columns = [
    {
      // S126: translated by the stable code, like the group above.
      name: t_('Type'),
      field: 'code',
      render: (row) => systemValueLabel(t_, 'alarm_type', row.code)
    },
    {
      name: t_('Subscribed'),
      field: 'effective',
      render: (row) => renderToggle('TYPE', row.code)
    },
    // S121: only a user has an origin to show — a profile inherits from nobody (RN13).
    ...(renderOrigin
      ? [{
          name: t_('Origin'),
          field: 'own',
          render: (row) => renderOrigin('TYPE', row.code)
        }]
      : []),
    // S123/S124: the column exists for every type row, but it only PAINTS something for the two job
    // types once they are subscribed. Everything else keeps being a single toggle per row (S148).
    ...(renderJobFilter
      ? [{
          name: t_('Job filter'),
          field: 'acceptsJobFilter',
          search: false,
          render: (row) => renderJobFilter(row)
        }]
      : [])
  ]

  return (
    <SmartMateriaUITable
      columns={columns}
      dataFetch={() => types}
      toolbarDisplay='none'
      searchDisplay='none'
      dense
      sticky={false}
    />
  )
}

export default AlarmSubscriptionTypes
